<script>
    

</script>

<section id="contact">
    <div id='container'>
        <div id='container-text'>
            <h1>Contact</h1>
            <p>Use the form below or email me directly at</p>
            <p><a href="mailto:frederikwordoss@gmail.com">frederikwordoss@gmail.com</a></p>
        </div>
        <div class="form-container">
            <form action="https://formspree.io/f/xdknnave" method="POST">
                <div class="form-field">
                    <label for="name" class="form-label">Your Name</label>
                    <input type="text" id="name" name="name" class="form-input" placeholder="Enter name..." required>
                </div>
                <div class="form-field">
                    <label for="email" class="form-label">Your Email</label>
                    <input type="email" id="email" name="email" class="form-input" placeholder="Enter your email..." required>
                </div>
                <div class="form-field">
                    <label for="message" class="form-label">Your Message</label>
                    <textarea id="message" name="message" class="form-textarea" placeholder="Enter your message..." rows="5" required></textarea>
                </div>
                <button type="submit" class="form-button">Send -></button>
            </form>
        </div>
    </div>
</section>


<style>
    #container {
        padding-left: 10%;
        padding-right: 10%;
        width: 100vw - 20%;
        height: calc(100vh - 80px);
        background-color: rgba(200, 255, 120, 0.2);
        display: flex;
        justify-content: start;
        flex-direction: column;
        align-items: center;
    }

    #container-text {
        width: 40%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    h1 {
        font-size: 48px;
        color: rgba(0, 0, 0, 0.9);
        margin-top: 20%;
        margin-bottom: 0px;
        text-align: center;
    }

    p {
        font-size: 18px;
        color: rgba(0, 0, 0, 0.5);
        margin-top: 11px;
        margin-bottom: 0px;
        text-align: center;
    }

    .form-container {
        margin-top: 48px;
        width: 50%;
        border-radius: 12px;
    }
    .form-field {
        margin-bottom: 20px;
    }
    .form-label {
        display: block;
        font-weight: bold;
        margin-bottom: 5px;
    }
    .form-input {
        width: 100%;
        padding: 10px;
        border: 3px solid #eee;
        border-radius: 8px;
        box-sizing: border-box;
    }
    .form-textarea {
        width: 100%;
        padding: 10px;
        border: 3px solid #eee;
        border-radius: 8px;
        box-sizing: border-box;
        resize: vertical;
    }
    .form-button {
        width: 100%;
        padding: 16px;
        border: 3px solid rgba(0, 0, 0, 0.9);
        border-radius: 8px;
        background-color: rgba(12, 108, 216, 0.2);
        color: rgba(0, 0, 0, 0.7);
        font-weight: bold;
        cursor: pointer;
        transition: 0.2s ease;
    }
    .form-button:hover {
        background-color: rgba(12, 108, 216, 0.4);
    }


    @media (max-width: 952px) {
        #container {
            display: block;
            flex-direction: column;
            margin-left: 0px;
            margin-right: 0px;
            padding: 0%;
            width: 100vw;
            height: calc(70vh);
            height: auto;
            padding-bottom: 48px;
        }
        #container-text {
            width: 100vw;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }
        .form-container {
            width: calc(100% - 48px);
            margin-left: 24px;
            margin-right: 24px;
        }
    }

</style>